import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isClient, isFreeProfessional, isGuest, isProfessional, } from '@/utils/resources/auth/authResource';
export const useSeminarAuth = () => {
    const auth = useSelector((state) => state.auth);
    return useMemo(() => {
        const isGuestUser = isGuest(auth);
        const isClientUser = isClient(auth);
        const isProfessionalUser = isProfessional(auth);
        const isFreeProfessionalUser = isFreeProfessional(auth);
        let userType = 'guest';
        if (isClientUser) {
            userType = 'client';
        }
        else if (isProfessionalUser || isFreeProfessionalUser) {
            userType = 'professional';
        }
        return {
            isClientUser,
            isFreeProfessionalUser,
            isGuestUser,
            isProfessionalUser,
            userType,
        };
    }, [auth]);
};
export default useSeminarAuth;
